import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './SearchBar.css';

import { DataStore } from '../DataStore';

@observer
class SearchBar extends Component {

    state = {
        value:''
    }

    searchKeyword = () => {
        if(this.state.value) {
            DataStore.keyword = this.state.value;
            DataStore.page = 1;
            DataStore.searchSongListStore();
        }else{
            DataStore.keyword = '';
            DataStore.page = 0;
            DataStore.newSongListStore();
        }
    }

    onClickBtn = (event) => {
        this.searchKeyword();
    }

    onKeyUp = (event) => {
        if(event.keyCode === 13 || event.keyCode === 108) {
            this.searchKeyword();
        }
    }

    onTextChange = (event) => {
        this.setState({
            value: event.target.value
        });
    }

    selectSource = (event) => {
        DataStore.dataSource = parseInt(event.target.getAttribute('type'), 10);
        //console.log(DataStore.dataSource)
    }

    render() {
        return (
            <div className="search-box">
                <div className="search-left">
                    <div className="search-tap">
                        <div className={"iconfont icon-wangyi" + (DataStore.dataSource === 1 ? " curr" : "")}
                            onClick={this.selectSource}
                            type="1"></div>
                        <div className={"iconfont icon-kugou" + (DataStore.dataSource === 2 ? " curr" : "")}
                            onClick={this.selectSource}
                            type="2"></div>
                    </div>
                    <div className="search-input">
                        <input type="text" placeholder="搜索歌曲或歌手"
                        value={this.state.value} 
                        onChange={this.onTextChange} onKeyUp={this.onKeyUp} />
                    </div>
                </div>
                <div className="search-btn">
                    <button className="iconfont icon-search" 
                    onClick={this.onClickBtn}></button>                
                </div>
            </div>
        );
    }
}

export default SearchBar;


// WEBPACK FOOTER //
// ./src/components/SearchBar.js